import React, { useMemo } from 'react';
import classnames from 'classnames';
import { SlidebarBtnPropsType } from '../../types';
import './index.scss';
import { Direction } from '../../enums';
import SvgIcon from '@/pages/home/components/SvgIcon';

const SlidebarBtn: React.FC<SlidebarBtnPropsType> = (props) => {
  const { className, style, disabled, direction, onClick } = props;

  const directionClassName = useMemo(() => {
    if (direction === Direction.Left) return 'common-slidebar-btn-left';
    if (direction === Direction.Right) return 'common-slidebar-btn-right';
    return '';
  }, [direction]);

  const handleClick = () => {
    if (disabled) return;
    if (onClick instanceof Function) {
      onClick(direction);
    }
  };

  return (
    <div
      style={style}
      className={classnames(
        'common-slidebar-btn',
        { disabled },
        className,
        directionClassName,
      )}
      onClick={handleClick}
    >
      <SvgIcon type="agent-left-arrow" className="common-slidebar-btn-icon" />
    </div>
  );
};

export default React.memo(SlidebarBtn);
